import React from 'react';

import { Link } from 'react-router-dom';
import { StyledCTA } from './styles';
import useDashboardLinkPrefix from '../../../hooks/useDashboardLinkPrefix';
import BoligmappaPlusHome from '../../../assets/images/BoligmappaPlus.png';
import useIsDesktop from '../../../hooks/v2/useDesktop';

const HomeCallToAction = ({ className }) => {
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const isDesktop = useIsDesktop();
  return (
    <StyledCTA className={className}>
      <div className="text_section">
        {isDesktop && (
          <div className="new_batch">
            <p className="new_text">Nyhet!</p>
          </div>
        )}
        <h2>{isDesktop ? 'Prøv Boligmappa+ nå!' : 'Prøv Boligmappa Pluss!'}</h2>
        <p>
          {isDesktop
            ? 'Med Boligmappa+ får du tilgang til en rekke nye og spennende funksjoner. Mye blir lansert i januar og utover, få early bird-tilgang nå!'
            : 'Med Boligmappa Pluss får du tilgang til en rekke nye og spennende funksjoner.'}
        </p>
        <div className="button_section">
          <Link
            to={`${dashboardLinkPrefix}/boligmappa-plus`}
            className="learn_more"
          >
            <button type="submit" className="early_bird">
              {isDesktop ? 'Få early bird her!' : 'Les mer'}
            </button>
          </Link>
          {isDesktop && (
            <Link
              to={`${dashboardLinkPrefix}/boligmappa-plus`}
              className="learn_more"
            >
              <p>Lær mer om Boligmappa+</p>
            </Link>
          )}
        </div>
      </div>
      <div className="image_section">
        <img
          alt="Boligmappa+"
          src={BoligmappaPlusHome}
          className="landscape-horizonal"
        />
      </div>
    </StyledCTA>
  );
};

export default HomeCallToAction;
